import * as React from "react";
import { HTMLTable } from "@blueprintjs/core";
import { schemeGnBu } from "../../utils/colours";

interface LegendRow {
  color: string;
  text: string;
}

export function ViralAnnotationTrackLegend() {
  function renderTrackRows() {
    const ecTypes = [
      { color: schemeGnBu[1], text: "3'UTR" },
      { color: schemeGnBu[3], text: "5'UTR" },
      { color: schemeGnBu[5], text: "CDS" },
      { color: schemeGnBu[7], text: "mat peptide" },
      { color: schemeGnBu[8], text: "EC7 Translocases" },
      // { color: "dimgray", text: "All Other CDS" },
    ];

    const rows: JSX.Element[] = [];
    ecTypes.forEach((ecType: LegendRow) => {
      rows.push(
        <tr key={ecType.color}>
          <td className="legend-table-element">
            <div
              className="legend-inner"
              style={{
                backgroundColor: ecType.color,
              }}
            />
          </td>
          <td className="legend-table-element">{ecType.text}</td>
        </tr>
      );
    });
    return rows;
  }

  return (
    <HTMLTable bordered={false} interactive={false} className="legend-table">
      <tbody>{renderTrackRows()}</tbody>
    </HTMLTable>
  );
}
